import gql from 'graphql-tag';

const PreviousPageListFragment = gql`
	fragment PreviousPageListFragment on PTPaginatedPageList {
		nodes {
			...PreviousPageInfoFragment
		}
		pageInfo {
			hasNextPage
		}
	}
`;

const PreviousPageInfoFragment = gql`
	fragment PreviousPageInfoFragment on PTPage {
		id
		title
		status
		createdDate(format: MILLIS) {
			value
		}
		hasChildren
		blank
		hasRestrictions @include(if: $isSuperAdmin)
		hasInheritedRestrictions @include(if: $isSuperAdmin)
		type
		links {
			webui
		}
		properties(keys: ["emoji-title-published", "emoji-title-draft", "editor"]) {
			nodes {
				id
				key
				value
				version {
					number
				}
			}
		}
	}
`;

/*
  If you add an optional property to PreviousPageInfoFragment then you need to duplicate this query.
  See https://product-fabric.atlassian.net/browse/SCALE-4250 for more details
*/
/*
  GraphQLPageStatus comes from monolith and PTGraphQLPageStatus comes
  from cc-page-tree and they need to be separate due to a Braid bug:
  https://product-fabric.atlassian.net/browse/SCALE-4686
*/
export const PageTreePreviousItemsQuery = gql`
	query PageTreePreviousItemsQuery(
		$spaceKey: String!
		$ptStatuses: [PTGraphQLPageStatus]
		$contentId: ID!
		$paginationLimit: Int
		$isSuperAdmin: Boolean!
	) {
		currentPage: ptpage(
			id: $contentId
			spaceKey: $spaceKey
			pageTree: $paginationLimit
			status: $ptStatuses
			enablePaging: true
		) {
			...PreviousPageInfoFragment
			nearestAncestors {
				pageInfo {
					hasNextPage
				}
				nodes {
					...PreviousPageInfoFragment
					previousSiblings {
						...PreviousPageListFragment
					}
				}
			}
			previousSiblings {
				...PreviousPageListFragment
			}
		}
	}

	${PreviousPageInfoFragment}
	${PreviousPageListFragment}
`;
